// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAaoGwHoyLUygT4nHz9E44ldxTOsMLX7gc',
    authDomain: 'kofc-ohio-dev.firebaseapp.com',
    databaseURL: 'https://kofc-ohio-dev.firebaseio.com',
    projectId: 'kofc-ohio-dev',
    storageBucket: 'kofc-ohio-dev.appspot.com',
    messagingSenderId: '6169638074'
  },
  fraternalYear: '2025-2026',
  googleTrackingID: 'UA-11891659-3'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
